/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiASkip2BackIcon20Solid = forwardRef('MediaUiASkip2BackIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M0 4a1 1 0 0 1 2 0v4.455l6.583-5.087C9.569 2.606 11 3.308 11 4.555v3.9l6.583-5.087C18.569 2.606 20 3.308 20 4.555v10.89c0 1.246-1.431 1.95-2.417 1.187L11 11.545v3.9c0 1.246-1.431 1.95-2.417 1.187L2 11.545V16a1 1 0 1 1-2 0V4Z" })));
});
